import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule } from '@angular/router';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { ModalModule } from 'ngx-bootstrap/modal';

import { NumberOnlyDirective } from './directives/number.directive';

import { TreeModule } from 'angular-tree-component';


import { AppComponent } from './app.component';
import { HomeComponent } from './components/home.component';

import { CscaeService } from './services/cscae.service';
/*
import { AppConfig } from './services/app.config';

export function initializeApp(appConfig: AppConfig) {
  return () => appConfig.load();
}
*/
@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    NumberOnlyDirective
  ],
  imports: [
    BrowserModule,
    CommonModule,
        HttpModule,
        FormsModule,
        TreeModule,
        TooltipModule.forRoot(),
        PopoverModule.forRoot(),
        ModalModule.forRoot(),
        RouterModule.forRoot([
            { path: '', redirectTo: 'home', pathMatch: 'full' },
            { path: 'home/:hash', component: HomeComponent },
            { path: '**', redirectTo: 'home' }
        ],{useHash:true})
  ],
  providers: [
    CscaeService,
    { provide: 'BASE_URL', useFactory: getBaseUrl }
   /*
    AppConfig,
    { provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppConfig], multi: true }    
      */
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }


export function getBaseUrl() {
  //console.log("BaseURL");
  //console.log(document.getElementsByTagName('baseurl')[0].textContent);
  return document.getElementsByTagName('baseurl')[0].textContent;
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts